import React from 'react'

import {
  T_Filter,
  T_FilterValueOption,
  T_FilterValueType,
} from '../state/filtersStore'
import { ContentExpander } from './ContentExpander'

const FilterQuestion = ({
  selectedFilter,
  value,
  setValue,
  descExpanded,
  setDescExpanded,
  onSave,
  onChange,
  onSkip,
  inWizard,
}: {
  selectedFilter: T_Filter
  value: boolean | string | undefined
  setValue: React.Dispatch<React.SetStateAction<boolean | string | undefined>>
  descExpanded: boolean
  setDescExpanded: React.Dispatch<React.SetStateAction<boolean>>
  onSave?: () => void
  onChange?: (value: boolean | string) => void
  onSkip?: () => void
  inWizard?: boolean
}) => {
  return selectedFilter ? (
    <div className='filter-question'>
      <p className='filter-question__question'>{selectedFilter.question}</p>

      <div className='filter-question__value-selector-wrapper'>
        <FilterValueSelector
          valueType={selectedFilter.value_type}
          selectOptions={selectedFilter.select_options}
          value={value}
          onChange={
            onChange
              ? (value) => {
                  onChange(value)
                }
              : setValue
          }
        />

        {value !== undefined ? (
          <button
            className='filter-question__save-btn'
            onClick={onSave ? onSave : undefined}
          >
            <span>Save</span>
            <i className='fa-solid fa-angle-right'></i>
          </button>
        ) : (
          <>
            {inWizard && (
              <button onClick={onSkip ? onSkip : undefined}>
                <span>Skip</span>
              </button>
            )}
          </>
        )}
      </div>

      <button
        className='filter-question__read-more-btn'
        onClick={() => {
          setDescExpanded(!descExpanded)
        }}
      >
        <span>{!descExpanded ? 'Read more' : 'Read less'}</span>
        <i
          className={`fa-solid ${!descExpanded ? 'fa-angle-down' : 'fa-angle-up'}`}
        ></i>
      </button>

      <ContentExpander expanded={descExpanded}>
        <div
          className='filter-question__description'
          dangerouslySetInnerHTML={{ __html: selectedFilter.description }}
        />
      </ContentExpander>
    </div>
  ) : null
}

const FilterValueSelector = ({
  valueType,
  selectOptions,
  value,
  onChange,
}: {
  valueType: T_FilterValueType
  selectOptions?: T_FilterValueOption[]
  value?: boolean | string
  onChange: (value: boolean | string) => void
}) => {
  return (
    <div
      className={[
        'filter-value-selector',
        valueType === 'boolean' && 'filter-value-selector--buttons-wrapper',
        valueType === 'select' && 'filter-value-selector--select-wrapper',
      ].join(' ')}
    >
      {/* Boolean, Yes/No */}
      {valueType === 'boolean' && (
        <>
          <button
            key={String(true)}
            className={[
              'filter-value-selector__button',
              value !== undefined &&
                String(value) === String(true) &&
                'filter-value-selector__button--selected',
            ].join(' ')}
            onClick={() => onChange(true)}
          >
            Yes
          </button>
          <button
            key={String(false)}
            className={[
              'filter-value-selector__button',
              value !== undefined &&
                String(value) === String(false) &&
                'filter-value-selector__button--selected',
            ].join(' ')}
            onClick={() => onChange(false)}
          >
            No
          </button>
        </>
      )}

      {/* Select dropdown */}
      {valueType === 'select' && (
        <select
          className='filter-value-selector__select'
          value={value == null ? '' : String(value)}
          onChange={(e) => {
            onChange(e.target.value)
          }}
        >
          <option value='' disabled>
            Choose:
          </option>

          {selectOptions?.map((option) => {
            return (
              <option key={String(option.value)} value={String(option.value)}>
                {option.label}
              </option>
            )
          })}
        </select>
      )}

      {/* {options.map((option) => (
        <button
          key={String(option.value)}
          className={[
            'filter-value-selector__button',
            value !== undefined &&
              String(value) === String(option.value) &&
              'filter-value-selector__button--selected',
          ].join(' ')}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))} */}
    </div>
  )
}

export { FilterQuestion }
